<template>
  <div>
    <!-- Селекты для добавления языка и уровня -->
    <div class="row" v-if="filtredLangs.length > 0">
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label">{{ pll[`Language`] }}</label>
          <div class="form-icon position-relative">
            <select
              id="selectLanguage"
              name="language"
              class="form-select"
              v-model="idSelectLang"
              @change="setLevel"
            >
              <option
                v-for="(value, key) in filtredLangs"
                :key="key"
                :value="value.term_id"
              >
                {{ value.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label">{{ pll[`Language level`] }}</label>
          <div class="form-icon position-relative inline-btn">
            <select
              id="selectLanguageLevel"
              name="language"
              class="form-select"
              v-model="idSelectLangLevel"
              @change.prevent="addLang()"
            >
            <option value="" disabled selected>{{ pll[`Select a level`] }}</option>
              <option
                v-for="(value, key) in getLevels(idSelectLang)"
                :key="key"
                :value="value.term_id"
              >
                {{ value.name }}
              </option>
            </select>
            <!-- <button
              @click.prevent="addLang()"
              class="btn btn-primary"
              v-if="filtredLangs.length > 0"
            >
              Select
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Вывод языков которые уже выбрал -->
    <div
      class="shadow-sm p-2 bg-light mb-3 rounded"
      v-for="(lang, key) in canSpeak"
      :key="key"
    >
      <div class="row align-items-center">
        <div class="col-md-6">
          <span>{{ getLangByID(lang.langID).name }}</span>
        </div>
        <div class="col-md-6">
          <div class="inline-btn align-items-center">
            <span>{{ getLangByID(lang.langID, lang.levelID)[0].name }}</span>
            <button
              class="btn btn-danger"
              @click.prevent="removeLang(lang.langID)"
            >
              <i data-feather="minus-circle" class="fea"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Вывод языков которые уже выбрал -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      filtredLangs: [], // оставшиеся доступные языки
      canSpeak: [], // языки которые знает
      idSelectLang: null, // ид выбраного языка для связывания селектов
      idSelectLangLevel: null,
    };
  },
  props: {
    languages: {
      type: Object,
      required: true,
    },
    user_languages: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addLang() {
      this.canSpeak.push({
        langID: this.idSelectLang,
        levelID: this.idSelectLangLevel,
      });
      this.setLanguages(); // обновляем оставшиеся доступные языки
      //   feather.replace();
    },
    removeLang(langID) {
      let indexToRemove = this.canSpeak.findIndex(
        (lang) => lang.langID === langID
      );
      this.canSpeak.splice(indexToRemove, 1);
      this.setLanguages();
    },
    setLanguages() {
      // фильтруем языки. если в массиве canSpeak есть хотя бы один язык из всего массива языков - то не показываем его
      this.filtredLangs = this.languages.filter((language) => {
        return !this.canSpeak.some((el) => {
          return el.langID === language.term_id;
        });
      });

      this.resetIDs(); //сбрасываем ид языка и уровня, чтобы по дефолту показывался первый язык из массива и первый уровень
    },
    setLevel() {
      //при выборе первого селекта с языком этот метод возвращает ид первого уровня языка
      // this.idSelectLangLevel = this.getLangByID(
      //   this.idSelectLang
      // ).children[0].term_id;
    },

    getLevels(termID) {
      // возвращает массив уровней определенного языка
      return this.filtredLangs.filter((lang) => {
        return lang.term_id === termID;
      })[0].children;
    },

    getLangByID(termID, subTermID = false) {
      // возвращает терм по заданым параметрам. по умолчанию возвращает терм только языка,
      // но если еть второй параметр возвращает терм уровня
      const lang = this.languages.filter((el) => {
        return el.term_id === termID;
      })[0];

      if (subTermID) {
        return lang.children.filter((el) => {
          return el.term_id === subTermID;
        });
      }

      return lang;
    },

    getCanSpeak() {
      // получает массив языков которые знает юзер и превращает его в нужный вид
      if (this.user_languages) {
        this.canSpeak = this.user_languages.reduce((acc, cur, index) => {
          if (index % 2 === 0) {
            acc.push({ langID: parseInt(cur) });
          } else {
            acc[acc.length - 1].levelID = parseInt(cur);
          }
          return acc;
        }, []);
      }else{
		this.canSpeak = []
	  }
    },

    resetIDs() {
      // сбрасывает ид языка и уровня
      if (this.filtredLangs.length > 0) {
        this.idSelectLang = this.filtredLangs[0].term_id;
        this.idSelectLangLevel = null;
      }
    },

    sendCanSpeak() {
      // отправляет в родительский элемент переделанный массив под добавление в вп
      const clearArray = this.canSpeak.reduce(
        (acc, cur) => [...acc, cur.langID, cur.levelID],
        []
      );
      this.$emit("sendCanSpeak", clearArray);
    },
  },
  watch: {
    canSpeak: {
      handler: function () {
        this.sendCanSpeak();
        setTimeout(() => {
          feather.replace();
        }, 1);
      },
      deep: true,
    },
  },
  beforeMount() {
    this.getCanSpeak();
    this.setLanguages();
  },
};
</script>